import React, { useCallback, useContext, useState } from 'react';
import CloseIcon from 'mdi-react/CloseIcon';

import { AppContext } from '@prisjakt/ui-app-context';

import ReportModal from './report-modal';

import { StockStatus, Price } from '../../../../types';

import * as S from './styles';

type OwnProps = {
  onClose: () => void;
  priceValue?: number | null;
  priceStore: Price['store'];
  productImage?: string | null;
  priceId?: string | null;
  productName?: string | null;
  stockStatus?: StockStatus | null;
};

const ReportButton = ({
  onClose,
  priceValue,
  priceStore,
  productImage,
  priceId,
  productName,
  stockStatus,
}: OwnProps) => {
  const { t } = useContext(AppContext);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleOnClose = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      onClose();
    },
    [onClose]
  );

  const closeIcon = <CloseIcon />;

  const openModal = useCallback(
    (e: React.MouseEvent) => {
      // Stops the PriceRow link and onClick from firing
      e.preventDefault();
      e.stopPropagation();

      setModalIsOpen(true);
    },
    [setModalIsOpen]
  );

  const closeModal = useCallback(() => setModalIsOpen(false), [setModalIsOpen]);

  return (
    <>
      <ReportModal
        isOpen={modalIsOpen}
        closeModal={closeModal}
        onClose={onClose}
        priceId={priceId}
        priceValue={priceValue}
        priceStore={priceStore}
        productImage={productImage}
        productName={productName}
        stockStatus={stockStatus}
      />

      <S.ReportOverlay>
        <S.PromptTitle>
          {t('feedback', 'dialog.prompt-title')}

          <S.ToggleButtons type="button" onClick={openModal}>
            {t('feedback', 'dialog.prompt-button')}
          </S.ToggleButtons>
        </S.PromptTitle>

        <S.CloseButton
          variant="icon"
          icon={closeIcon}
          onClick={handleOnClose}
        />
      </S.ReportOverlay>
    </>
  );
};

export default ReportButton;
